import React, { useState, useEffect } from "react";
/* eslint-disable react-hooks/exhaustive-deps */
import Table from "../../shared/components/pagination/Datatable.jsx";
import { AlertCircle } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../core/api/config";
import EditRastreamento from "../rastreamento/editrastreamento.jsx";
import Loader from "../../shared/components/Loader.jsx";
import BotaoSuporte from "../components/BotaoSuporte.jsx";
import { useSelector } from "react-redux";
import SelecaoEstabelecimentoModal from "./components/SelecaoEstabelecimentoModal.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal } from "bootstrap";
import { normalizeNomeBusca } from "../../shared/utils/normalizeNomeBusca";
import { maskCpf } from "../../shared/utils/maskCpf";

import {
  setAcessos,
  setAcessoAtivo,
} from "../../core/redux/access/accessActions";

const FILTROS_SELECIONADOS_INICIAIS = {
  statusColoId: [],
  statusMamaId: [],
  tipoRastreamentoId: null,
  resultadoColoId: [],
  resultadoHistoricoColoId: null,
  resultadoCitMamaId: null,
  resultadoHistoricoMamaId: null,
  resultadoMamografiaId: [],
};

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCloseSelecaoModal = () => {
    // limpar localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("acessoAtivo");
    localStorage.removeItem("acessos");
    localStorage.removeItem("estabelecimentoSelecionado");

    // limpar redux
    dispatch(setAcessos([]));
    dispatch(setAcessoAtivo(null));

    // redirecionar para login
    navigate("/signin", { replace: true });
  };
  const acessoAtivo = useSelector((state) => state.access.acessoAtivo);
  const organogramaId = acessoAtivo?.idOrganograma;
  const acessoRequestId = acessoAtivo?.id ?? organogramaId;
  const chaveAcessoAtivo = `${organogramaId ?? ""}-${acessoAtivo?.descricao ?? ""}`;
  const [showSelecaoModal, setShowSelecaoModal] = useState(false);

  useEffect(() => {
    const acessoSalvo = localStorage.getItem("acessoAtivo");
    if (!acessoSalvo) setShowSelecaoModal(true);
  }, []);

  const handleConfirmarAcesso = (acesso) => {
    localStorage.setItem("acessoAtivo", JSON.stringify(acesso));
    setShowSelecaoModal(false);

    //  Se for TODOS → vai para charts
    if (acesso.idOrganograma === "TODOS") {
      navigate("/charts-dashboard");
    } else {
      navigate("/admin-dashboard");
    }
  };

  const [, setAcessoId] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [idadeMinima, setIdadeMinima] = useState("");
  const [idadeMaxima, setIdadeMaxima] = useState("");
  const [buscaNome, setBuscaNome] = useState("");
  const [buscaCPF, setBuscaCPF] = useState("");

  const [dadosCards, setDadosCards] = useState({
    total_papa_atrasado: 0,
    total_agendar_primeiro_papa: 0,
    total_mamografia_atrasada: 0,
    total_agendar_primeira_mamografia: 0,
    total_controle_mama: 0,
    total_controle_colo: 0,
    total_controle_geral: 0,
    alterados_colo: 0,
    alterados_mama: 0,
  });

  const [totalResultados, setTotalResultados] = useState(0);
  const [, setLoading] = useState(false);
  const [loadingRastreamento, setLoadingRastreamento] = useState(false);

  const [erros, setErros] = useState({
    dataInicio: "",
    dataFim: "",
  });

  const paginationConfig = {
    current: currentPage + 1,
    pageSize: pageSize,
    total: totalElements,
    onChange: (page, size) => {
      const newPage = page - 1;
      setCurrentPage(newPage);
      setPageSize(size);

      fetchData({
        page: newPage,
        size: size,
      });
    },
    onShowSizeChange: (current, size) => {
      setCurrentPage(0);
      setPageSize(size);

      fetchData({
        page: 0,
        size: size,
      });
    },
  };

  useEffect(() => {
    const buscarAcessoUsuario = async () => {
      try {
        const response = await api.get("/api/user/show");
        const acesso = response.data.acesso;

        if (acesso && acesso.id) {
          const id = acesso.id;
          const nome = acesso.rel_estabelecimento.nome;

          localStorage.setItem(
            "estabelecimentoSelecionado",
            JSON.stringify({ id, nome }),
          );

          setAcessoId(id);
        }
      } catch (error) {
        console.error("Erro ao buscar acesso do usuário:", error);
      }
    };

    buscarAcessoUsuario();
  }, []);

  const carregarDadosCards = async () => {
    if (organogramaId == null) return;

    setLoading(true);
    try {
      // Criar payloads para cada card baseado nos filtros que você mostrou nos onClick

      // 1. Total controle colo - Mulheres Rastreadas para Câncer do Colo do Útero
      const payloadControleColo = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,
        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 64,
        idadeMinima: 25,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: [1, 2, 4, 5, 7, 8, 9],
        statusColoIds: null,
        statusMamaId: null,
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      // 2. Agendar Primeira Citologia
      const payloadAgendarPrimeiraCito = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,

        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 64,
        idadeMinima: 25,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: [3, 6],
        statusColoIds: null,
        statusMamaId: null,
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      // 3. Citologia Atrasada
      const payloadCitologiaAtrasada = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,

        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 64,
        idadeMinima: 25,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: [7],
        statusColoIds: null,
        statusMamaId: null,
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      // 4. Mulheres Rastreadas para Câncer de Mama
      const payloadControleMama = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,

        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 74,
        idadeMinima: 50,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: null,
        statusColoIds: null,
        statusMamaId: [1, 2, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15],
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      // 5. Agendar Primeira Mamografia
      const payloadAgendarPrimeiraMama = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,

        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 74,
        idadeMinima: 50,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: null,
        statusColoIds: null,
        statusMamaId: [3, 4],
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      // 6. Mamografia Atrasada
      const payloadMamografiaAtrasada = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,

        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        idadeMaxima: 74,
        idadeMinima: 50,
        nomePaciente: null,
        resultadoCitMamaId: null,
        resultadoColoId: null,
        resultadoHistoricoColoId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        statusColoId: null,
        statusColoIds: null,
        statusMamaId: [9],
        statusMamaIds: null,
        tipoRastreamentoId: null,
      };

      const [
        responseControleColo,
        responseAgendarPrimeiraCito,
        responseCitologiaAtrasada,
        responseControleMama,
        responseAgendarPrimeiraMama,
        responseMamografiaAtrasada,
      ] = await Promise.all([
        api.post("/api/tracking/cards", payloadControleColo),
        api.post("/api/tracking/cards", payloadAgendarPrimeiraCito),
        api.post("/api/tracking/cards", payloadCitologiaAtrasada),
        api.post("/api/tracking/cards", payloadControleMama),
        api.post("/api/tracking/cards", payloadAgendarPrimeiraMama),
        api.post("/api/tracking/cards", payloadMamografiaAtrasada),
      ]);

      // Atualizar dados dos cards
      setDadosCards({
        total_controle_colo: responseControleColo.data.total || 0,
        total_agendar_primeiro_papa:
          responseAgendarPrimeiraCito.data.total || 0,
        total_papa_atrasado: responseCitologiaAtrasada.data.total || 0,
        total_controle_mama: responseControleMama.data.total || 0,
        total_agendar_primeira_mamografia:
          responseAgendarPrimeiraMama.data.total || 0,
        total_mamografia_atrasada: responseMamografiaAtrasada.data.total || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar dados dos cards:", error);
      // Valores de fallback em caso de erro
    } finally {
      setLoading(false);
    }
  };

  const formatarNumero = (numero) => {
    return new Intl.NumberFormat("pt-BR").format(numero);
  };

  const aplicarFiltroCard = (novosFiltros) => {
    const filtrosZerados = {
      statusColoId: [],
      statusMamaId: [],
      tipoRastreamentoId: null,
      resultadoColoId: [],
      resultadoHistoricoColoId: null,
      resultadoCitMamaId: null,
      resultadoHistoricoMamaId: null,
      resultadoMamografiaId: [],
    };

    const filtrosAtualizados = {
      ...filtrosZerados,
      ...novosFiltros,
    };

    // atualizar estados visuais
    setIdadeMinima(novosFiltros.idadeMinima?.toString() || "");
    setIdadeMaxima(novosFiltros.idadeMaxima?.toString() || "");

    setFiltrosSelecionados(filtrosAtualizados);
    setCurrentPage(0);

    fetchData({
      page: 0,
      size: pageSize,
      filtros: filtrosAtualizados,
      nome: "",
      cpf: "",
      idadeMin: novosFiltros.idadeMinima || "",
      idadeMax: novosFiltros.idadeMaxima || "",
      dataInicio: null,
      dataFim: null,
    });
  };

  const [filtrosDropdown, setFiltrosDropdown] = useState(null);
  const [filtrosSelecionados, setFiltrosSelecionados] = useState({
    ...FILTROS_SELECIONADOS_INICIAIS,
  });

  const carregarFiltrosDropdown = async () => {
    setLoading(true);
    try {
      const response = await api.get("/api/tracking/filtros-dropdown");
      setFiltrosDropdown(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    carregarFiltrosDropdown();

    if (organogramaId != null) {
      setBuscaNome("");
      setBuscaCPF("");
      setIdadeMinima("");
      setIdadeMaxima("");
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setFiltrosSelecionados(FILTROS_SELECIONADOS_INICIAIS);
      setCurrentPage(0);
      setTotalElements(0);
      setTotalResultados(0);
      setPacienteSelecionado(null);
      setErros({
        dataInicio: "",
        dataFim: "",
      });

      carregarDadosCards();
      fetchData({
        page: 0,
        size: pageSize,
        filtros: FILTROS_SELECIONADOS_INICIAIS,
        nome: "",
        cpf: "",
        idadeMin: "",
        idadeMax: "",
        dataInicio: null,
        dataFim: null,
      });
    }
  }, [chaveAcessoAtivo]);

  useEffect(() => {
    const buscarAcessoUsuario = async () => {
      try {
        const response = await api.get("/api/user/show");
        const acesso = response.data.acesso;

        if (acesso && acesso.rel_estabelecimento?.id) {
          localStorage.setItem(
            "estabelecimentoSelecionado",
            JSON.stringify({ id: acesso.rel_estabelecimento.id }),
          );
        }
      } catch (error) {
        console.error("Erro ao buscar acesso do usuário:", error);
      }
    };

    buscarAcessoUsuario();
  }, []);

  // MAPEAMENTO DE DADOS RASTREAMENTO
  const mapRastreamentoItem = (item) => {
    return {
      id: item.pessoa?.id,
      nome: item.pessoa?.nome || "-",
      nomeMae: item.pessoa?.nomeMae || "-",
      cpf: item.pessoa?.cpf || "-",
      statusColo: item.tipoDeAlerta?.descricao || "-",
      statusMama: item.tipoDeAlertaMama?.descricao || "-",
      tipoRastreio: item.tipoRastreamento?.descricao || "-",
      jaUnificado: !!item.jaUnificado,
    };
  };

  // FUNÇÃO PRINCIPAL PARA BUSCAR DADOS
  const fetchData = async ({
    page = currentPage,
    size = pageSize,
    filtros = filtrosSelecionados,
    nome = buscaNome,
    cpf = buscaCPF,
    idadeMin = idadeMinima,
    idadeMax = idadeMaxima,
    dataInicio = selectedStartDate,
    dataFim = selectedEndDate,
  } = {}) => {
    if (organogramaId == null) return;

    setLoadingRastreamento(true);

    try {
      const payload = {
        acessoId: acessoRequestId,
        idOrganograma: organogramaId,
        cnesIds: [],
        nomePaciente: nome?.trim() || null,
        cpf: cpf?.trim() || null,
        idadeMinima: idadeMin ? parseInt(idadeMin) : null,
        idadeMaxima: idadeMax ? parseInt(idadeMax) : null,
        dataInicioExame: dataInicio ?? null,
        dataFimExame: dataFim ?? null,
        statusMamaId: null,
        tipoRastreamentoId: null,
        resultadoColoId: null,
        resultadoCitMamaId: null,
        resultadoHistoricoMamaId: null,
        resultadoMamografiaId: null,
        obito: false,
        ...filtros,
      };

      const response = await api.post(
        `/api/tracking/organized-patient-tracking/por-acesso?acessoId=${acessoRequestId}&page=${page}&size=${size}`,
        payload,
      );

      const mappedData = response.data.content.map(mapRastreamentoItem);

      setDataSource(mappedData);
      setTotalResultados(response.data.totalElements);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoadingRastreamento(false);
    }
  };

  // FUNÇÃO PARA ATUALIZAR DASHBOARD APÓS PROCESSAMENTO
  const handleAtualizarDashboard = async () => {
    try {
      // Recarregar dados da tabela
      await fetchData({
        page: currentPage,
        size: pageSize,
      });

      // Recarregar dados dos cards
      await carregarDadosCards();
    } catch (error) {
      console.error("Erro ao atualizar dashboard:", error);
    }
  };

  // Exportar Dados
  const [loadingExport, setLoadingExport] = useState(false);
  const handleExportarDados = async () => {
    if (organogramaId == null) return;

    setLoadingExport(true);

    try {
      const payload = {
        idOrganograma: organogramaId,
        cnesIds: [],
        nomePaciente: buscaNome?.trim() || null,
        cpf: buscaCPF?.trim() || null,
        idadeMinima: idadeMinima ? parseInt(idadeMinima) : null,
        idadeMaxima: idadeMaxima ? parseInt(idadeMaxima) : null,
        dataInicioExame: selectedStartDate ?? null,
        dataFimExame: selectedEndDate ?? null,
        ...filtrosSelecionados,
      };

      const response = await api.post(
        "/api/tracking/organized-patient-tracking/exportar-xls",
        payload,
        { responseType: "blob" },
      );

      // Verifica se veio conteúdo
      if (!response.data || response.data.size === 0) {
        alert("Nenhum dado encontrado para exportação.");
        return;
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "rastreamento.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao exportar:", error);
      alert("Erro ao gerar arquivo. Verifique o console.");
    } finally {
      setLoadingExport(false);
    }
  };

  const handleBuscaNomeChange = (e) => {
    setBuscaNome(normalizeNomeBusca(e.target.value));
  };

  const handleBuscaCPFChange = (e) => {
    const valor = e.target.value.replace(/\D/g, "");
    setBuscaCPF(valor.slice(0, 11));
  };

  const handleDataInicioChange = (e) => {
    const novaDataInicio = e.target.value;
    setSelectedStartDate(novaDataInicio);

    if (
      selectedEndDate &&
      new Date(novaDataInicio) > new Date(selectedEndDate)
    ) {
      setErros({
        dataInicio: "A data de início não pode ser maior que a data de fim.",
        dataFim: "",
      });
    } else {
      setErros((prev) => ({
        ...prev,
        dataInicio: "",
      }));
    }
  };

  const handleDataFimChange = (e) => {
    const novaDataFim = e.target.value;
    setSelectedEndDate(novaDataFim);

    if (
      selectedStartDate &&
      new Date(novaDataFim) < new Date(selectedStartDate)
    ) {
      setErros({
        dataInicio: "",
        dataFim: "A data de fim não pode ser menor que a data de início.",
      });
    } else {
      setErros((prev) => ({
        ...prev,
        dataFim: "",
      }));
    }
  };

  const removerFiltro = (chave) => {
    const novosFiltros = { ...filtrosSelecionados };
    let novoNome = buscaNome;
    let novoCPF = buscaCPF;
    let novaIdadeMin = idadeMinima;
    let novaIdadeMax = idadeMaxima;
    let novaDataInicio = selectedStartDate;
    let novaDataFim = selectedEndDate;

    if (chave in novosFiltros) {
      novosFiltros[chave] = Array.isArray(novosFiltros[chave]) ? [] : null;
    }

    if (chave === "buscaNome") {
      setBuscaNome("");
      novoNome = "";
    }
    if (chave === "buscaCPF") {
      setBuscaCPF("");
      novoCPF = "";
    }
    if (chave === "idadeMinima") {
      setIdadeMinima("");
      novaIdadeMin = "";
    }
    if (chave === "idadeMaxima") {
      setIdadeMaxima("");
      novaIdadeMax = "";
    }
    if (chave === "selectedStartDate") {
      setSelectedStartDate(null);
      novaDataInicio = null;
    }
    if (chave === "selectedEndDate") {
      setSelectedEndDate(null);
      novaDataFim = null;
    }

    setFiltrosSelecionados(novosFiltros);

    // Usar fetchData com os novos valores de filtros
    setTimeout(() => {
      fetchData({
        page: 0,
        size: pageSize,
        filtros: novosFiltros,
        nome: novoNome,
        cpf: novoCPF,
        idadeMin: novaIdadeMin,
        idadeMax: novaIdadeMax,
        dataInicio: novaDataInicio,
        dataFim: novaDataFim,
      });
    }, 0);
  };

  const handleLimparFiltros = async () => {
    if (organogramaId == null) return;

    const filtrosLimpos = FILTROS_SELECIONADOS_INICIAIS;

    // limpa estados
    setBuscaNome("");
    setBuscaCPF("");
    setIdadeMinima("");
    setIdadeMaxima("");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setFiltrosSelecionados(filtrosLimpos);
    setCurrentPage(0);

    // chama fetch passando valores zerados manualmente
    await fetchData({
      page: 0,
      size: pageSize,
      filtros: filtrosLimpos,
      nome: "",
      cpf: "",
      idadeMin: "",
      idadeMax: "",
      dataInicio: null,
      dataFim: null,
    });

    await carregarDadosCards();
  };

  const sinalizarUnificacaoTooltip = (
    <Tooltip id="sinalizar-unificacao-tooltip">Unificado</Tooltip>
  );


  const renderCitoAtrasadaTooltip = (props) => (
    <Tooltip id="citoatrasada-tooltip" {...props}>
      Mulheres que não realizaram o exame citológico do colo do útero no prazo
      previsto.
    </Tooltip>
  );

  const renderAgendarPrimeiraCitoTooltip = (props) => (
    <Tooltip id="agendarprimeiracito-tooltip" {...props}>
      Mulheres de 25-64 anos que ainda não realizaram o primeiro exame
      citológico do colo do útero
    </Tooltip>
  );

  const renderMamaAtrasadaTooltip = (props) => (
    <Tooltip id="mamaatrasada-tooltip" {...props}>
      Mulheres que não realizaram a mamografia no prazo previsto.
    </Tooltip>
  );

  const renderAgendarPrimeiraMamografiaTooltip = (props) => (
    <Tooltip id="agendarprimeiramama-tooltip" {...props}>
      Mulheres de 50-74 anos que ainda não realizaram a primeira mamografia
    </Tooltip>
  );

  const renderRastreamentoColoTooltip = (props) => (
    <Tooltip id="rastreamentocolo-tooltip" {...props}>
      Mulheres de 25-64 anos que estão participando do programa de rastreamento.
    </Tooltip>
  );

  const renderRastreamentoMamaTooltip = (props) => (
    <Tooltip id="pacientesrastreamentomama-tooltip" {...props}>
      Mulheres de 50-74 anos que estão participando do programa de rastreamento.
    </Tooltip>
  );

  const renderStatusBadge = (status) => {
    if (!status) {
      return <span className="badge badge-linegray">Sem informação</span>;
    }

    const badgeKey = status.trim().toLowerCase();

    const badgeMap = {
      "fora da idade de rastreio": "badge-linesecondary",
      "aguardando citologia": "badge-lineinfo",
      "citologia atrasada": "badge-linedanger",
      "citologia em dia": "badge-linesuccess",
      "encaminhar para tratamento": "badge-linewarning",
      "colposcopia atrasada": "badge-linedanger",
      "tratamento em atraso": "badge-linedanger",
      "aguardando colposcopia": "badge-lineinfo",
      "aguardando primeira citologia": "badge-lineinfo",
      "primeira citologia atrasada": "badge-linedanger",
      "aguardando primeira mamografia": "badge-lineinfo",
      "primeira mamografia atrasada": "badge-linedanger",
      "aguardando ultrassonografia": "badge-lineinfo",
      "ultrassonografia em atraso": "badge-linedanger",
      "ultrassonografia em dia": "badge-linesuccess",
      "aguardando mamografia": "badge-lineinfo",
      "mamografia atrasada": "badge-linedanger",
      "mamografia em dia": "badge-linesuccess",
      "aguardando biópsia": "badge-lineinfo",
      "biópsia atrasada": "badge-linedanger",
      "encaminhar para mastologista": "badge-linewarning",
      "sem informação": "badge-linegray",
    };

    const badgeClass = badgeMap[badgeKey] || "badge-linegray";

    return <span className={`badge ${badgeClass}`}>{status}</span>;
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      sorter: (a, b) => a.nome.length - b.nome.length,
      render: (text, record) => (
        <span className="position-relative d-inline-block pe-4">
          <span className="ms-2 d-inline-block">{text}</span>
          {record.jaUnificado && (
            <span
              className="position-absolute top-0 start-100 badge rounded-pill badge-linewarning fw-normal"
              style={{
                fontSize: "0.64rem",
                lineHeight: 1,
                padding: "0.3rem 0.5rem",
                opacity: 0.8,
                whiteSpace: "nowrap",
                transform: "translate(-25%, -50%)",
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={sinalizarUnificacaoTooltip}
              >
                <span>U</span>
              </OverlayTrigger>
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Nome da Mãe",
      dataIndex: "nomeMae",
      sorter: (a, b) => a.nomeMae.length - b.nomeMae.length,
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      sorter: (a, b) => a.cpf.length - b.cpf.length,
    },
    {
      title: "Status de Colo do Útero",
      dataIndex: "statusColo",
      sorter: (a, b) => a.statusColo?.localeCompare(b.statusColo),
      render: (text) => renderStatusBadge(text),
    },
    {
      title: "Status da Mama",
      dataIndex: "statusMama",
      sorter: (a, b) => a.statusMama.length - b.statusMama.length,
      render: (text) => renderStatusBadge(text),
    },
    {
      title: "Tipo de Rastreio",
      dataIndex: "tipoRastreio",
      sorter: (a, b) => a.tipoRastreio.length - b.tipoRastreio.length,
    },
    {
      title: "Ações",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => {
            setPacienteSelecionado(record);
            const modalElement = document.getElementById("edit-rastreamento");
            const modal = new Modal(modalElement);
            modal.show();
          }}
        >
          <i className="feather-eye" />
        </button>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <BotaoSuporte />
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Rastreamento do Câncer do Colo do Útero </h4>
              </div>
            </div>
          </div>
          <div className="row">
            {/* Cards do dashboard */}
            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderRastreamentoColoTooltip}
              >
                <div
                  className="dash-count das2 custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      // tipoRastreamentoId: 1,
                      statusColoId: [1, 2, 4, 5, 7, 8, 9],
                      idadeMinima: 25,
                      idadeMaxima: 64,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>{formatarNumero(dadosCards.total_controle_colo)}</h4>
                    <h5>Mulheres Rastreadas para Câncer do Colo do Útero</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>

            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderAgendarPrimeiraCitoTooltip}
              >
                <div
                  className="dash-count das1 custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      statusColoId: [3, 6],
                      idadeMinima: 25,
                      idadeMaxima: 64,
                      // tipoRastreamentoId: 3,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>
                      {formatarNumero(dadosCards.total_agendar_primeiro_papa)}
                    </h4>
                    <h5>Agendar Primeira Citologia</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>

            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderCitoAtrasadaTooltip}
              >
                <div
                  className="dash-count custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      idadeMaxima: 64,
                      idadeMinima: 25,
                      statusColoId: [7],
                      // tipoRastreamentoId: 1,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>{formatarNumero(dadosCards.total_papa_atrasado)}</h4>
                    <h5>Citologia Atrasada</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>
          </div>

          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Rastreamento do Câncer de Mama</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderRastreamentoMamaTooltip}
              >
                <div
                  className="dash-count das2 custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      // tipoRastreamentoId: 2,
                      statusMamaId: [1, 2, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15],
                      idadeMinima: 50,
                      idadeMaxima: 74,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>{formatarNumero(dadosCards.total_controle_mama)}</h4>
                    <h5>Mulheres Rastreadas para Câncer de Mama</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>

            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderAgendarPrimeiraMamografiaTooltip}
              >
                <div
                  className="dash-count das1 custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      statusMamaId: [3, 4],
                      idadeMinima: 50,
                      idadeMaxima: 74,
                      // tipoRastreamentoId: 2,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>
                      {formatarNumero(
                        dadosCards.total_agendar_primeira_mamografia,
                      )}
                    </h4>
                    <h5>Agendar Primeira Mamografia</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>

            <div className="col-xl-4 col-sm-6 col-12 d-flex">
              <OverlayTrigger
                placement="bottom"
                overlay={renderMamaAtrasadaTooltip}
              >
                <div
                  className="dash-count custom-hover-card"
                  onClick={() =>
                    aplicarFiltroCard({
                      statusMamaId: [9],
                      idadeMaxima: 74,
                      idadeMinima: 50,
                      // tipoRastreamentoId: 2,
                    })
                  }
                >
                  <div className="dash-counts">
                    <h4>
                      {formatarNumero(dadosCards.total_mamografia_atrasada)}
                    </h4>
                    <h5>Mamografia Atrasada</h5>
                  </div>
                  <div className="dash-imgs">
                    <AlertCircle />
                  </div>
                </div>
              </OverlayTrigger>
            </div>
          </div>

          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Filtros</h4>
              </div>
            </div>
          </div>

          <div className="card p-3">
            <div className="row row-gap-3 mb-3">
              <div className="col-md-6 col-lg-2">
                <label htmlFor="nomeInput" className="form-label">
                  Nome
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={buscaNome}
                  onChange={handleBuscaNomeChange}
                  id="nomeInput"
                />
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="cpfInput" className="form-label">
                  CPF
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={maskCpf(buscaCPF)}
                  onChange={handleBuscaCPFChange}
                  id="cpfInput"
                />
              </div>
            </div>
            <div className="row row-gap-3 mb-3">
              <div className="col-md-6 col-lg-2">
                <label htmlFor="idadeMinimaInput" className="form-label">
                  Idade mínima
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={idadeMinima}
                  onChange={(e) => setIdadeMinima(e.target.value)}
                  id="idadeMinimaInput"
                />
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="idadeMaximaInput" className="form-label">
                  Idade máxima
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="idadeMaximaInput"
                  value={idadeMaxima}
                  onChange={(e) => setIdadeMaxima(e.target.value)}
                />
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="dataInicioInput" className="form-label">
                  Início da liberação de exame
                </label>
                <input
                  type="date"
                  className={`form-control ${erros.dataInicio ? "is-invalid" : selectedStartDate ? "is-valid" : ""}`}
                  id="dataInicioInput"
                  value={selectedStartDate || ""}
                  onChange={handleDataInicioChange}
                  onBlur={() => {
                    if (!selectedStartDate) {
                      setErros((prev) => ({
                        ...prev,
                        dataInicio: "A data de início é obrigatória.",
                      }));
                    }
                  }}
                />
                {erros.dataInicio && (
                  <div className="invalid-feedback">{erros.dataInicio}</div>
                )}
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="dataFimInput" className="form-label">
                  Fim da liberação de exame
                </label>
                <input
                  type="date"
                  className={`form-control ${erros.dataFim ? "is-invalid" : selectedEndDate ? "is-valid" : ""}`}
                  id="dataFimInput"
                  value={selectedEndDate || ""}
                  onChange={handleDataFimChange}
                  onBlur={() => {
                    if (!selectedEndDate) {
                      setErros((prev) => ({
                        ...prev,
                        dataFim: "A data de fim é obrigatória.",
                      }));
                    }
                  }}
                />
                {erros.dataFim && (
                  <div className="invalid-feedback">{erros.dataFim}</div>
                )}
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="tipoRastreioSelect" className="form-label">
                  Tipo de rastreio
                </label>

                <select
                  className="form-select"
                  id="tipoRastreioSelect"
                  value={filtrosSelecionados.tipoRastreamentoId || ""}
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      tipoRastreamentoId: e.target.value
                        ? parseInt(e.target.value)
                        : null,
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.tipoRastreamento
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="obitoSelect" className="form-label">
                  Filtrar por óbito
                </label>
                <select
                  className="form-select"
                  id="obitoSelect"
                  value={filtrosSelecionados.obito ? "true" : "false"}
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      obito: e.target.value === "true",
                    }))
                  }
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>
            </div>
            <h5 className="mb-3">Colo do Útero</h5>
            <div className="row row-gap-3 mb-3">
              <div className="col-md-6 col-lg-2">
                <label htmlFor="statusColoSelect" className="form-label">
                  Status
                </label>
                <select
                  className="form-select"
                  id="statusColoSelect"
                  value={
                    filtrosSelecionados.statusColoId?.length
                      ? filtrosSelecionados.statusColoId[0]
                      : ""
                  }
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      statusColoId: e.target.value
                        ? [parseInt(e.target.value)]
                        : [],
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.statusColo
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="resultCitoColoSelect" className="form-label">
                  Resultado Citopatológico
                </label>
                <select
                  className="form-select"
                  id="resultCitoColoSelect"
                  value={
                    filtrosSelecionados.resultadoColoId?.length
                      ? filtrosSelecionados.resultadoColoId[0]
                      : ""
                  }
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      resultadoColoId: e.target.value
                        ? [parseInt(e.target.value)]
                        : [],
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.resultadosColo
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="resultHistoColoSelect" className="form-label">
                  Resultado Histopatológico
                </label>
                <select
                  className="form-select"
                  id="resultHistoColoSelect"
                  value={filtrosSelecionados.resultadoHistoricoColoId || ""}
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      resultadoHistoricoColoId: e.target.value
                        ? parseInt(e.target.value)
                        : null,
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.resultadoshistoricoColo
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <h5 className="mb-3">Mama</h5>
            <div className="row row-gap-3 mb-3">
              <div className="col-md-6 col-lg-2">
                <label htmlFor="statusMamaSelect" className="form-label">
                  Status
                </label>

                <select
                  className="form-select"
                  id="statusMamaSelect"
                  value={
                    filtrosSelecionados.statusMamaId?.length
                      ? filtrosSelecionados.statusMamaId[0]
                      : ""
                  }
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      statusMamaId: e.target.value
                        ? [parseInt(e.target.value)]
                        : [],
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.statusMama
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-lg-2">
                <label htmlFor="resultMamografiaSelect" className="form-label">
                  Resultado Mamografia
                </label>
                <select
                  className="form-select"
                  id="resultMamografiaSelect"
                  value={
                    filtrosSelecionados.resultadoMamografiaId?.length
                      ? filtrosSelecionados.resultadoMamografiaId[0]
                      : ""
                  }
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      resultadoMamografiaId: e.target.value
                        ? [parseInt(e.target.value)]
                        : [],
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.resultadoMamografia
                    ?.filter((item) => item.id !== 0)
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-lg-2">
                <label
                  htmlFor="resultadoHistoMamaSelect"
                  className="form-label"
                >
                  Resultado Histopatológico
                </label>
                <select
                  className="form-select"
                  id="resultadoHistoMamaSelect"
                  value={filtrosSelecionados.resultadoHistoricoMamaId || ""}
                  onChange={(e) =>
                    setFiltrosSelecionados((prev) => ({
                      ...prev,
                      resultadoHistoricoMamaId: e.target.value
                        ? parseInt(e.target.value)
                        : null,
                    }))
                  }
                >
                  <option value="">Selecione uma opção ...</option>
                  {filtrosDropdown?.resultadoHistoricoMama
                    ?.sort((a, b) => a.id - b.id)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="row row-gap-3 mb-3">
              <div className="col-md-6 col-lg-2">
                <button
                  className="btn btn-primary d-block w-100"
                  onClick={() =>
                    fetchData({
                      page: 0,
                      size: pageSize,
                    })
                  }
                >
                  <i data-feather="search" className="feather-search" />
                  <span className="ms-2">Buscar</span>
                </button>
              </div>
              <div className="col-md-6 col-lg-2">
                <button
                  className="btn btn-secondary d-block w-100"
                  onClick={handleLimparFiltros}
                >
                  <i data-feather="x" className="feather-x" />
                  <span className="ms-2">Limpar</span>
                </button>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <strong>Filtros aplicados: </strong>
                    <div className="mt-2 d-flex flex-wrap gap-2">
                      {buscaNome && (
                        <span className="badge badge-linesuccess">
                          Nome: {buscaNome}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("buscaNome")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {buscaCPF && (
                        <span className="badge badge-linesuccess">
                          CPF: {buscaCPF}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("buscaCPF")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {idadeMinima && (
                        <span className="badge badge-linesuccess">
                          Idade mínima: {idadeMinima}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("idadeMinima")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {idadeMaxima && (
                        <span className="badge badge-linesuccess">
                          Idade máxima: {idadeMaxima}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("idadeMaxima")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {selectedStartDate && (
                        <span className="badge badge-linesuccess">
                          Início:{" "}
                          {selectedStartDate.split("-").reverse().join("/")}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("selectedStartDate")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {selectedEndDate && (
                        <span className="badge badge-linesuccess">
                          Fim: {selectedEndDate.split("-").reverse().join("/")}
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("selectedEndDate")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {filtrosSelecionados.statusColoId?.length > 0 &&
                        filtrosDropdown?.statusColo && (
                          <span className="badge badge-linesuccess">
                            Status de Colo do Útero:{" "}
                            {filtrosSelecionados.statusColoId
                              .map(
                                (id) =>
                                  filtrosDropdown.statusColo.find(
                                    (item) => item.id === id,
                                  )?.descricao,
                              )
                              .filter(Boolean)
                              .join(", ")}
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() => removerFiltro("statusColoId")}
                            >
                              ×
                            </span>
                          </span>
                        )}

                      {filtrosSelecionados.statusMamaId?.length > 0 &&
                        filtrosDropdown?.statusMama && (
                          <span className="badge badge-linesuccess">
                            Status Mama:{" "}
                            {filtrosSelecionados.statusMamaId
                              .map(
                                (id) =>
                                  filtrosDropdown.statusMama.find(
                                    (item) => item.id === id,
                                  )?.descricao,
                              )
                              .filter(Boolean)
                              .join(", ")}
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() => removerFiltro("statusMamaId")}
                            >
                              ×
                            </span>
                          </span>
                        )}

                      {filtrosSelecionados.tipoRastreamentoId &&
                        filtrosDropdown?.tipoRastreamento && (
                          <span className="badge badge-linesuccess">
                            Tipo Rastreio:{" "}
                            {
                              filtrosDropdown.tipoRastreamento.find(
                                (item) =>
                                  item.id ===
                                  filtrosSelecionados.tipoRastreamentoId,
                              )?.descricao
                            }
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() =>
                                removerFiltro("tipoRastreamentoId")
                              }
                            >
                              ×
                            </span>
                          </span>
                        )}
                      {filtrosSelecionados.obito && (
                        <span className="badge badge-linesuccess">
                          Óbito: Sim
                          <span
                            className="ms-1 cursor-pointer text-success"
                            onClick={() => removerFiltro("obito")}
                          >
                            ×
                          </span>
                        </span>
                      )}
                      {filtrosSelecionados.resultadoColoId?.length > 0 &&
                        filtrosDropdown?.resultadosColo && (
                          <span className="badge badge-linesuccess">
                            Resultado de Colo do Útero:{" "}
                            {filtrosSelecionados.resultadoColoId
                              .map(
                                (id) =>
                                  filtrosDropdown.resultadosColo.find(
                                    (item) => item.id === id,
                                  )?.descricao,
                              )
                              .filter(Boolean)
                              .join(", ")}
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() => removerFiltro("resultadoColoId")}
                            >
                              ×
                            </span>
                          </span>
                        )}

                      {filtrosSelecionados.resultadoHistoricoColoId &&
                        filtrosDropdown?.resultadoshistoricoColo && (
                          <span className="badge badge-linesuccess">
                            Histopatológico de Colo do Útero:{" "}
                            {
                              filtrosDropdown.resultadoshistoricoColo.find(
                                (item) =>
                                  item.id ===
                                  filtrosSelecionados.resultadoHistoricoColoId,
                              )?.descricao
                            }
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() =>
                                removerFiltro("resultadoHistoricoColoId")
                              }
                            >
                              ×
                            </span>
                          </span>
                        )}
                      {filtrosSelecionados.resultadoMamografiaId?.length > 0 &&
                        filtrosDropdown?.resultadoMamografia && (
                          <span className="badge badge-linesuccess">
                            Resultado Mamografia:{" "}
                            {filtrosSelecionados.resultadoMamografiaId
                              .map(
                                (id) =>
                                  filtrosDropdown.resultadoMamografia.find(
                                    (item) => item.id === id,
                                  )?.descricao,
                              )
                              .filter(Boolean)
                              .join(", ")}
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() =>
                                removerFiltro("resultadoMamografiaId")
                              }
                            >
                              ×
                            </span>
                          </span>
                        )}

                      {filtrosSelecionados.resultadoHistoricoMamaId &&
                        filtrosDropdown?.resultadoHistoricoMama && (
                          <span className="badge badge-lineinfo">
                            Histopatológico Mama:{" "}
                            {
                              filtrosDropdown.resultadoHistoricoMama.find(
                                (item) =>
                                  item.id ===
                                  filtrosSelecionados.resultadoHistoricoMamaId,
                              )?.descricao
                            }
                            <span
                              className="ms-1 cursor-pointer text-success"
                              onClick={() =>
                                removerFiltro("resultadoHistoricoMamaId")
                              }
                            >
                              ×
                            </span>
                          </span>
                        )}
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <span className="badge bg-primary">
                      {totalResultados} resultados
                    </span>
                  </div>

                  <button
                    className="btn btn-primary"
                    onClick={handleExportarDados}
                    disabled={loadingExport}
                  >
                    {loadingExport ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Baixando...
                      </>
                    ) : (
                      <>
                        <i className="feather-download me-2"></i>
                        Exportar Dados
                      </>
                    )}
                  </button>
                </div>

                {loadingRastreamento ? (
                  <Loader />
                ) : dataSource.length === 0 ? (
                  <div className="text-center p-4">
                    <p className="text-muted">
                      Nenhum registro encontrado com os filtros aplicados.
                    </p>
                  </div>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={paginationConfig}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditRastreamento
        pacienteSelecionado={pacienteSelecionado}
        onClose={() => setPacienteSelecionado(null)}
        onPacienteProcessado={handleAtualizarDashboard}
      />

      <SelecaoEstabelecimentoModal
        show={showSelecaoModal}
        onClose={handleCloseSelecaoModal}
        onConfirm={handleConfirmarAcesso}
      />
    </div>
  );
};

export default Dashboard;
